import { isSpanContextValid, trace } from '@opentelemetry/api';

/**
 * 現在アクティブな OTel span の trace_id / span_id を返す。
 *
 * pino の browser ビルドは `mixin` に非対応のため、`browser.formatters.log` から
 * 呼び出して各ログレコードへ trace 相関フィールドを付与する用途で使う
 * (設計 05 §3.2 / 07 §3.3)。フィールド名は Go/Bun と揃えて snake_case。
 * アクティブ span が無い / SpanContext が無効な場合は空オブジェクトを返す。
 */
export function traceLogMixin(): { trace_id?: string; span_id?: string } {
  const span = trace.getActiveSpan();
  if (!span) {
    return {};
  }
  const spanContext = span.spanContext();
  if (!isSpanContextValid(spanContext)) {
    return {};
  }
  return { trace_id: spanContext.traceId, span_id: spanContext.spanId };
}
